import { takeLatest } from 'redux-saga/effects';
import { twoFactorSubmitResend } from './twoFactorSaga';
import { TWO_FACTOR } from '../../actions/twoFactor';

function* twoFactorSagas() {
  yield takeLatest(TWO_FACTOR.SUBMIT, twoFactorSubmitResend);
}

export default twoFactorSagas;
